/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_Totp_Remove_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not remove the authenticator device." |
*
* @param {Profile_Security_Totp_Remove_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_totp_remove_error = /** @type {((inputs?: Profile_Security_Totp_Remove_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Totp_Remove_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Authenticator-Gerät konnte nicht entfernt werden.")
	return /** @type {LocalizedString} */ ("Could not remove the authenticator device.")
});